<template>
  <v-col cols="12">
          <div>
            <v-row v-if="this.serie.approval">
              <v-col>
              <v-text-field
              v-model.number="serie.approval.criteria[0].hitCount"
                label="Hit count"
                 type="number"
              ></v-text-field>
                </v-col>
                <v-col>
            <v-text-field
                v-model.number="serie.approval.criteria[0].hitFactor"
                label="Hit factor"
                 type="number"
                 step="0.01"
                  min="0"
              ></v-text-field>   
              </v-col>
            </v-row>
            <div v-if="serie.targetScoringDefinition">
              <v-select
                :items="validHitZones"
                v-model="hitZoneList" 
                item-text="name"  
                multiple
                label="Valid hit zones"
                @input="emitFormattedHitZones"
                return-object
              ></v-select>
            </div>
          </div>
  </v-col>
</template>

<script>
export default {
  name: 'EditSeriesApproval',
  apollo: {
    $client: 'shootingProgramClient',
  },
  props: {
    serie: Object,
  },
  mounted() {
    //Fill callouts with missing values if exists.
    if(!this.serie.approval){
      this.serie.approval= {
      criteria: []
    }
    this.serie.approval.criteria.push({
        hitCount: 0,
        hitFactor: 0.0,
        validZones: []
      })
    } else {
      if(this.serie.approval.criteria[0].validZones.length > 0){
        const existingZones = new Set(this.serie.approval.criteria[0].validZones.map(item => item.id));

        const felles = this.validHitZones.filter(item => existingZones.has(item.id));
        this.hitZoneList = felles;
      }
    }


  },

  computed: {
    validHitZones() {
      if(!this.serie.targetScoringDefinition)
        return [];

      if(this.serie.targetScoringDefinition.length === 0)
        return [];

      const scoringConvert = this.serie.targetScoringDefinition[0].scoringConvert || [];
          const hitZones = []
      scoringConvert.flatMap((scoring) => {
        return scoring.hitZoneConvert.map((hitZone) => {
          const hitZoneElement = {
            ...hitZone,
            name: `${scoring.name} - ${hitZone.name}`,
          };
          hitZones.push(hitZoneElement);
          return hitZoneElement;
        });
      });
    
      return hitZones;
    }
  },

  data: () => ({
    hitZoneList: []
  }),
  methods: {
    emitFormattedHitZones(newHitZoneList) {
        const formattedData = newHitZoneList.map(hitZone => ({
          id: hitZone.id
        }));
        this.serie.approval.criteria[0].validZones = formattedData;
    }
  }

};
</script>
